import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { uniqBy } from "lodash";
import { db, http } from "../../common/lib";
import config from "../../config";
import actions from "../actions";
import { actionCreators, actionTypes } from "./actions";
import { get } from "idb-keyval";
import { logToSentry } from "../../config/Sentry";

function* getAssignmentStatus() {
    try {
        const localState = yield select((state) => state);
        let pendingSubmissionDB =
            (yield call(get, db.types.pendingSubmission)) || [];
        const assignmentIds = [];
        localState.auditAssignments.data.forEach((assignment) => {
            pendingSubmissionDB.find(
                (item) => item.assignmentId === assignment.id
            );
            assignmentIds.push(assignment.id);
        });

        const suspendedAssignmentIds = [];
        const suspenededAuditIds = [];
        if (assignmentIds.length > 0) {
            const { data } = yield call(
                http.authorized.post,
                config.api.paths.auditAssignmentStatus,
                {
                    assignment_ids: assignmentIds,
                }
            );

            data &&
                data.map((item) =>
                    item.status === "suspended"
                        ? suspendedAssignmentIds.push(item.id)
                        : []
                );

            localState.auditAssignments.data.forEach((assignment) => {
                if (suspendedAssignmentIds.includes(assignment.id))
                    suspenededAuditIds.push(assignment.auditLocation.audit.id);
            });
        }

        yield put(actionCreators.statusSelectSuccess(suspenededAuditIds));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("get assignment status", {
            error,
            errStr,
        });
        yield put(actionCreators.statusSelectFailure(errStr));
    }
}

function* selectAssignments() {
    try {
        const { auth } = yield select((state) => state);

        let auditAssignments =
            (yield call(get, db.types.auditAssignment)) || [];

        let pendingSubmissionDB =
            (yield call(get, db.types.pendingSubmission)) || [];

        // extract locations that belong to logged-in user
        const auditLocations = auditAssignments.reduce((accum, item) => {
            if (item.auditor === auth.account.id)
                accum.push(item.auditLocation);

            return accum;
        }, []);

        const audits = auditLocations.map((item) => item.audit);
        let uniqueAudits = uniqBy(audits, "id");
        // display the ones that are not processed
        const auditIdsToDisplay = pendingSubmissionDB.map(
            (item) => item.auditId
        );
        uniqueAudits = uniqueAudits.filter((item) =>
            auditIdsToDisplay.includes(item.id)
        );

        yield all([
            put(actionCreators.selectSuccess(auditAssignments)),
            put(actions.auditLocations.create.selectSuccess(auditLocations)),
            put(actions.audits.create.selectSuccess(uniqueAudits)),
            /*
                after all audits fetched, we need to collect their orgIds and request typeList for each org
            */
            put(actions.typesList.create.getRequest(uniqueAudits)),
        ]);
    } catch (error) {
        const errStr = error.toString();
        logToSentry("select assignment status", {
            error,
            errStr,
        });
        yield put(actionCreators.selectFailure(errStr));
    }
}

export { selectAssignments, getAssignmentStatus };

export default (function* () {
    yield all([
        takeLatest(
            actions.auditUpload.type.AUDIT_UPLOAD_POST_SUCCESS,
            selectAssignments
        ),
        takeLatest(
            actionTypes.AUDIT_ASSIGNMENTS_SELECT_REQUEST,
            selectAssignments
        ),
        takeLatest(
            actionTypes.AUDIT_ASSIGNMENTS_STATUS_SELECT_REQUEST,
            getAssignmentStatus
        ),
    ]);
})();
